import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let TechniciansAdApiPromise: Promise<AxiosInstance> | null = null;

const getTechniciansAdApi = async (): Promise<AxiosInstance | null> => {
  if (TechniciansAdApiPromise !== null) return TechniciansAdApiPromise;
  TechniciansAdApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return TechniciansAdApiPromise;
};

export interface ActiveDirectoryTechnicianUser {
  id: string;
  displayName: string;
  givenName: string;
  surname: string;
  userPrincipalName: string;
  mail: string;
}

export interface GetTechniciansActiveDirectoryUsersProps {
  busqueda?: string;
}

export const getTechniciansActiveDirectoryUsers = async (
  props: GetTechniciansActiveDirectoryUsersProps,
): Promise<ActiveDirectoryTechnicianUser[] | null> => {
  const api = await getTechniciansAdApi();
  if (!api) return null;

  const qs = objectToQueryStringWithArray(props);
  const url = qs
    ? `/Tecnicos/GetListadoTecnicosAD?${qs}`
    : "/Tecnicos/GetListadoTecnicosAD";

  const response = await api.get(url);
  return response.data;
};
